<template>
    <div class="logo">
        <img :src="Web.Url(appData.default.logo)" :alt="appData.name">
    </div>
    <div class="card">
        <div class="card-header">
            <div class="title">
                <span>GENEL SUNUCU HATASI</span>
            </div>
        </div>
        <div class="card-body">
            <div class="mb-3 text-center">
                <!--<i class="fa fa-bug text-danger"></i>-->
                <i class="fa fa-circle-exclamation text-danger"></i>
                <p>Bilinmeyen Bir Hata Oluştu!</p>
                <p>{{ msg }}</p>
            </div>
        </div>
        <div class="card-footer">
            <router-link class="btn btn-primary" :to="Links.Url(Links.Home)">
                <i class="fa fa-house"></i>
                <span>Anasayfaya Git</span>
            </router-link>
            <button class="btn btn-secondary" @click="$router.back()">
                <i class="fa fa-rotate-left"></i>
                <span>Geri Dön</span>
            </button>
        </div>
    </div>
</template>
<script>
    export default {
        name: "PageError",
        props: {
            page: String,
            msg: String,
        },
    };
</script>
